import React, { useState } from 'react'
import classNames from 'classnames'

import Header from '@/components/newHeader/Header'
import Footer from '@/components/newFooter'
import styles from './customer.module.scss'
import BasicHeadSeo from '@/components/basicHeadSeo'

type FaqItem = {
  question: string
  answer: string | string[]
}

function Faq() {
  const [openItemIndex, setOpenItemIndex] = useState(null)

  const openItem = (index) => {
    if (openItemIndex === index) setOpenItemIndex(null)
    else setOpenItemIndex(index)
  }

  const faqs: FaqItem[] = [
    {
      question: 'How does Mawoo Pets work?',
      answer:
        "Finding a puppy on Mawoo Pets is simple. You can browse puppies by breed, location, or type of dog, and view our available puppies across the US and Canada. Once you find a puppy you like, you can review his or her profile, read about the puppy's parents, registrations, paperwork, and any health guarantees offered by the breeder. You can then complete a reservation request for the puppy and make a deposit payment to secure the puppy for your home. Our team will then coordinate pickup or delivery of the puppy for you. Finding a puppy on our website is simple. Start by inputting your zip code, and we will find you available puppies by family and registered kennels in your area. Once you find a puppy you like, you can get in touch with the breeder, schedule a site visit, or a video chat visit online! Once you find your puppy match, you can make the purchase directly on our website, and we will co-ordinate pickup or delivery of your puppy",
    },
    {
      question: 'Can I meet the dog?',
      answer:
        'Yes! You can schedule a site visit with the breeder to meet the puppy and see their Kennel. If an in-person visit is difficult, you can also schedule an online call to meet both the puppy and the kennel. We understand that it’s very important for you to meet your future dog, and want to make sure you “feel that connection” before making a selection.',
    },
    {
      question: 'What breeders do you work with?',
      answer: [
        'We work with family and registered kennels across the US & Canada. Every breeder on our website has been vetted by our strict protocols on the health, safety, and socialization of puppies. We ensure that the puppy and its parents have received the right health checks, deworming, and veterinary care. Further, we ensure that parents are nurtured and housed with care and safety –a healthy mom means a healthy puppy!',
        'Most importantly, we work with breeders who are in this business for the love of dogs, and who truly care about finding the right homes for their puppies. ',
      ],
    },
    {
      question: 'Do you work with shelters or rescues?',
      answer:
        'We do not at this time. However, we are eagerly looking to expand to these centers, as we believe tremendously in the role they play for dogs. We hope to broaden our scope to include not only puppies, but dogs of any ages and from any source, to achieve our mission of helping dogs find caring families. ',
    },
    {
      question: 'What is the average price of a dog?',
      answer:
        'The price of dogs is set by breeders and ranges based on the breed and geography of the dog. Prices can range from $1,000 to $5,000, with most averaging under $2,500. ',
    },
    {
      question:
        'Why would I find a puppy through Mawoo Pets vs. on Craigslist, Kijiji, or elsewhere?',
      answer: [
        'Craigslist and many other sources online leave the buyer in the dark. Who is the kennel? What licenses and registrations do they have? What is their reputation? What health & safety checks do they perform?',
        'We make this process simple and transparent. All of our breeders are licensed and vetted, and you can review their profiles and experiences. We perform health & safety checks &validations for all kennels.We co-ordinate pickup & delivery to ensure your puppy arrives in your hands safely. Lastly, once you purchase a puppy, we share all documents and records with you electronically – from veterinary checks to microchip certificates –to make this process as easy and safe as possible for you.  ',
      ],
    },
    {
      question: 'How do I purchase a dog on your platform? ',
      answer:
        'This process is simple. First, you submit a reservation request for the puppy that you are interested in. You can then submit a deposit payment to secure the puppy for your home. Our team will coordinate on travel or pickup of your puppy within 24 hours of your reservation submission. Payments can be made via credit card, Apple Pay, Google Pay, or one of our financing options (Community Finance, Klarna, etc.) This process is simple. First, you submit an application for any dog that you are interested in. If your application is approved by the Kennel, your dog is secured, and you can finalize your payment. Payments can be made via credit card, PayPal, or direct bank deposits. We ensure that your payment is kept secure until you have received your puppy, at which point your payment is released to the Kennel. ',
    },
  ]
  return (
    <div className={styles.content}>
      <h1 className={styles.title}>Frequently Asked Questions</h1>
      {faqs.map((faq, index) => (
        <div key={index} className={styles.faq}>
          <div className={styles.body}>
            <div className={styles.question}>
              {faq.question}
              <div className={styles.plus} onClick={() => openItem(index)}>
                <img src="/landing/plus-green.svg" alt="Green plus icon" />
              </div>
            </div>
            <div
              className={classNames({
                [styles.answers]: true,
                [styles.open]: openItemIndex === index,
              })}
            >
              {Array.isArray(faq.answer)
                ? faq.answer.map((a, index1) => (
                    <div className={styles.answer} key={index1}>
                      {' '}
                      {a}{' '}
                    </div>
                  ))
                : faq.answer}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default function CustomerFaq() {
  return (
    <div id="customerfaq">
      <BasicHeadSeo
        title="FAQ - Customer"
        url={`${process.env.NEXT_PUBLIC_ROOT_URL}/faq/customer`}
        description="Finding a puppy on Mawoo Pets is simple. You can browse puppies by breed, location, or type of dog, and view our available puppies across the US and Canada."
      />
      <main className={styles.main}>
        <Header />
        <Faq />
        <Footer />
      </main>
    </div>
  )
}
